<template>
  <!-- 新建采购单 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="66%"
    @ok="handleOk"
    @cancel="handleCancel"
    :dialog-style="{ top: '20px' }"
  >
    <div v-if="maskDiv" class="maskDiv" @click="maskClick" />
    <div>
      <a-form-model
        ref="formRef"
        :model="form"
        labelAlign="right"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="formRules"
      >
        <a-form-model-item
          label="对应项目"
          prop="projectName"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-input
            v-model="form.projectName"
            placeholder="点击选择项目"
            read-only
            class="choosePerson"
            @click="openModal('project')"
          />
        </a-form-model-item>
        <!-- <a-form-model-item  v-if="purchasingReqList.length" label="对应采购申请" prop="purchaseRequisitionId" :labelCol="rowLabel" :wrapperCol="rowWrapper">
            <a-select :disabled="title === '[新建]采购单' ? false : true" @change="reqChange" v-model="form.purchaseRequisitionId" placeholder="请选择采购申请" style="width: 100%;">
              <a-select-option v-for="(item,index) in purchasingReqList" :key="index" :value="item.id">
                {{item.title}}
              </a-select-option>
            </a-select>
        </a-form-model-item>-->
        <a-form-model-item
          label="采购主题"
          prop="subject"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-input :disabled="isDisabled" v-model="form.subject" placeholder="请输入采购主题" />
        </a-form-model-item>
        <a-form-model-item
          label="供应商"
          prop="suppliersName"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-input
            :disabled="isDisabled"
            v-model="form.suppliersName"
            placeholder="点击选择供应商"
            read-only
            class="choosePerson"
            @click="openModal('supplier')"
          />
        </a-form-model-item>
        <a-form-model-item label="采购单号" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-input v-model="form.code" :disabled="true" />
        </a-form-model-item>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="采购日期" prop="purchaseDate">
              <a-date-picker
                :disabled="isDisabled"
                @change="timeChange"
                v-model="form.purchaseDate"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="采购分类" prop="classification">
              <a-select
                :disabled="isDisabled"
                v-if="cgTypeList.length"
                v-model="form.classification"
                placeholder="请选择采购分类"
                style="width: 100%;"
              >
                <a-select-option
                  v-for="(item,index) in cgTypeList"
                  :key="index"
                  :value="item.label"
                >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="供应商代表">
              <a-input :disabled="isDisabled" v-model="form.supplierName" placeholder="请输入供应商代表" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="我方代表">
              <a-input
                :disabled="isDisabled"
                v-model="form.ourName"
                placeholder="点击选择我方代表"
                read-only
                class="choosePerson"
                @click="openPerson('owner')"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item
          label="采购明细"
          prop="productList"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-button type="primary" @click="productDetailClick">编辑产品明细</a-button>
          <a-table
            class="cgClass"
            :columns="productColumns"
            :data-source="productList"
            :pagination="false"
            :rowKey="(record,index)=>{return index}"
            size="small"
            bordered
            :scroll="{x:900, y: 280 }"
          />
          <div>共 {{productList.length}} 条</div>
        </a-form-model-item>
        <a-form-model-item
          label="采购金额"
          prop="totalPrice"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-tooltip>
            <template slot="title">(该金额为本次采购的总金额，是采购明细中的总计金额和不需要入库产品金额的总和)</template>
            <!-- <a-input v-model="form.totalPrice" @blur="countMoney(1)" placeholder="请输入采购金额" style="width: 300px;margin-right: 10px;"/> -->
            <a-input-number
              placeholder="请输入采购金额"
              style="width: 37%;margin-right: 10px;"
              v-model="form.totalPrice"
              :disabled="isDisabled"
              :step="0.01"
              :min="-Infinity"
              :parser="value => (value.match(/-?\d*\.?(\d{1,2})?/) || [])[0] || ''"
              @blur="countMoney(1)"
            />
          </a-tooltip>
          <span>{{ dealBigMoneys(form.totalPrice) || '零元' }}</span>
        </a-form-model-item>
        <a-form-model-item
          v-if="form.totalPrice"
          label=" 金额计算说明"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >本单总金额 = 明细金额 {{productDetailMoney}} + 附加费用金额 {{form.extraPayMoney || 0}}</a-form-model-item>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="附加费用类型">
              <a-select
                :disabled="isDisabled"
                v-if="extraPayType.length"
                v-model="form.extraPayType"
                placeholder="请选择附加费用类型"
                style="width: 100%;"
              >
                <a-select-option
                  v-for="(item,index) in extraPayType"
                  :key="index"
                  :value="item.label"
                >{{item.value}}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="附加费用金额(元)">
              <!-- <a-input type="number" :min="0" v-model="form.extraPayMoney" @blur="countMoney(2)" placeholder="请输入附加费用金额"/> -->
              <a-input-number
                placeholder="请输入附加费用金额"
                style="width: 20em;"
                v-model="form.extraPayMoney"
                :disabled="isDisabled"
                :step="0.01"
                :parser="value => value.match(/^-?[0-9]*\.?[0-9]{0,2}/)[0]"
                @blur="countMoney(2)"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <div v-if="title === `[新建]${this.$tree([], 'purchase/purchaseNote/index')}`">
          <a-form-model-item label="付款情况" :labelCol="rowLabel" :wrapperCol="rowWrapper">
            <a-radio-group
              v-model="form.payType"
              @change="payTypeChange"
              style="margin: 0 10px;"
              :disabled="isDisabled"
            >
              <a-radio :value="0" @click="payTypeClick0">生成付款计划</a-radio>
              <a-radio :value="1" @click="payTypeClick1">生成付款记录</a-radio>
            </a-radio-group>
            <span v-if="form.payType === 0 || form.payType === 1">
              <b>收到发票:</b>
              <a-radio-group
                v-model="form.payInvoice"
                @change="payInvoiceChange"
                style="margin-left: 10px;"
                :disabled="isDisabled"
              >
                <a-radio :value="1">已收到</a-radio>
                <a-radio :value="0">未收到</a-radio>
                <a-radio :value="2">无需收票</a-radio>
              </a-radio-group>
            </span>
            <br />
            <a-row
              v-if="form.payType === 0 || form.payType === 1"
              :labelCol="rowLabel"
              :wrapperCol="rowWrapper"
            >
              <a-form-model
                ref="dynamicValidateForm"
                :model="dynamicValidateForm"
                v-bind="formItemLayoutWithOutLabel"
              >
                <a-row>
                  <div
                    v-for="(domain, index) in dynamicValidateForm.domains"
                    :key="index"
                    style="display:flex;"
                    class="domain-style"
                  >
                    <span class="numberCla">({{index + 1}})</span>
                    <div>
                      <a-form-model-item
                        label="付款金额"
                        v-bind="formItemLayout"
                        :prop="'domains.' + index + '.payMoney'"
                        :rules="{
                          required: true,
                          message: '请输入付款金额',
                          trigger: 'change',
                        }"
                        style="display: flex; width: 250px"
                      >
                        <a-input-number
                          :disabled="isDisabled"
                          v-model="domain.payMoney"
                          :precision="2"
                          style=" margin-right: 8px;width: 100px;"
                        />
                      </a-form-model-item>
                      <div>金额大写：{{ dealBigMoneys(domain.payMoney) || '零元' }}</div>
                    </div>
                    <a-form-model-item
                      label="款项日期"
                      v-bind="formItemLayout"
                      :prop="'domains.' + index + '.payDate'"
                      :rules="{
                          required: true,
                          message: '请选择款项日期',
                          trigger: 'change',
                        }"
                    >
                      <a-date-picker
                        :disabled="isDisabled"
                        v-model="domain.payDate"
                        @change="(date, dateString) => onChange(date, dateString, index )"
                        style="width: 130px;"
                      />
                    </a-form-model-item>
                    <a-form-model-item v-bind="formItemLayout" label="付款方式">
                      <a-select v-model="domain.payMode" :disabled="isDisabled">
                        <a-select-option
                          v-for="(item,index) in paymentMethodList"
                          :key="index"
                          :value="item.label"
                        >{{item.value}}</a-select-option>
                      </a-select>
                    </a-form-model-item>
                    <a-icon
                      v-if="dynamicValidateForm.domains.length > 1"
                      class="dynamic-delete-button deleteRowIcon"
                      type="minus-circle-o"
                      :disabled="dynamicValidateForm.domains.length === 1"
                      @click="removeDomain(domain)"
                    />
                  </div>
                </a-row>
                <a-form-model-item v-if="form.payType===0" v-bind="formItemLayoutWithOutLabel">
                  <a-button type="primary" style="width: 60%" @click="addDomain">
                    <a-icon type="plus" />继续添加计划
                  </a-button>
                </a-form-model-item>
              </a-form-model>
            </a-row>
          </a-form-model-item>
          <a-form-model-item
            v-if="form.payInvoice === 1"
            label="收票记录"
            :labelCol="rowLabel"
            :wrapperCol="rowWrapper"
          >
            <a-radio-group
              v-model="form.isTrue"
              @change="isTrueChange"
              style="margin-left: 10px;"
              :disabled="isDisabled"
            >
              <a-radio :value="true" @click="isTrueClick">生成一个收票记录</a-radio>
            </a-radio-group>
            <br />
            <a-row v-if="form.isTrue">
              <a-row>
                <a-col :span="7" class="colFlex">
                  <a-form-model-item
                    label="票据金额"
                    prop="invoiceBo.invoiceMoney"
                    :labelCol="spLabelCol"
                    :wrapperCol="spWrapper"
                  >
                    <a-input-number
                      :disabled="isDisabled"
                      v-model="form.invoiceBo.invoiceMoney"
                      :step="0.01"
                      :min="0"
                      :precision="2"
                      style="width:120px;"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" class="colFlex">
                  <a-form-model-item
                    label="票据类型"
                    prop="invoiceBo.invoiceType"
                    :labelCol="spLabelCol"
                    :wrapperCol="spWrapper"
                  >
                    <a-select
                      :disabled="isDisabled"
                      v-if="billTypeList.length"
                      v-model="form.invoiceBo.invoiceType"
                      style="width:120px;"
                      @change="ticketReceiptClick"
                    >
                      <a-select-option
                        v-for="(item,index) in billTypeList"
                        :key="index"
                        :value="item.label"
                      >{{item.value}}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="7" class="colFlex">
                  <a-form-model-item label="含税" :labelCol="spLabelCol" :wrapperCol="spWrapper">
                    <a-select
                      :disabled="isDisabled || isincludingTax"
                      v-model="form.invoiceBo.includingTax"
                      @change="rateChange"
                      style="width: 180px"
                    >
                      <a-select-option :value="0">含税</a-select-option>
                      <a-select-option :value="1">不含税</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="9" class="colFlex">
                  <a-form-model-item label="税率" :labelCol="spLabelCol" :wrapperCol="spWrapper">
                    <a-input-number
                      @blur="countTaxes"
                      v-model="form.invoiceBo.taxRate"
                      :disabled="isDisabled"
                      :min="0"
                      :max="10000"
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')"
                      style="width:180px;"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" class="colFlex">
                  <span>税金：{{form.invoiceBo.taxes}}</span>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="11" class="colFlex">
                  <a-form-model-item
                    label="发票号码"
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 16 }"
                  >
                    <a-input
                      :disabled="isDisabled"
                      v-model="form.invoiceBo.invoiceNum"
                      style="width: 280px;"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="13" class="colFlex">
                  <a-form-model-item
                    label="发票内容"
                    prop="invoiceBo.invoiceContent"
                    :labelCol="{ span: 8 }"
                    :wrapperCol="{ span: 16 }"
                  >
                    <a-input
                      :disabled="isDisabled"
                      v-model="form.invoiceBo.invoiceContent"
                      style="width: 300px;"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-row>
          </a-form-model-item>
        </div>
        <a-form-model-item label="关联订单客户" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-input
            :disabled="isDisabled"
            v-model="form.customerName"
            placeholder="点击选择关联订单客户"
            read-only
            class="choosePerson"
            @click="openModal('customer')"
          />
        </a-form-model-item>
        <a-form-model-item label="关联订单" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-select
            :disabled="isDisabled"
            v-model="form.otherContractName"
            @change="otherContractChange"
            placeholder="请选择关联订单"
            style="width: 100%;"
          >
            <a-select-option
              v-for="(item,index) in orderList"
              :key="index"
              :value="item.contractTitle"
              :matterCode="item.id"
            >{{item.contractTitle}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="采购概要" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-textarea
            v-model="form.content"
            placeholder="请输入备注"
            allowClear
            :disabled="isDisabled"
            :max-length="1000"
            :rows="3"
            showCount
            :autoSize="{ minRows: 3, maxRows: 20 }"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-radio-group :disabled="isDisabled" v-model="form.status" style="margin-left: 10px;">
            <a-radio :value="0">执行中</a-radio>
            <a-radio :value="1">结束</a-radio>
            <a-radio :value="2">意外中止</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="抄送人" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <p class="choosePerson" @click="openPerson('user')">{{ form.userName || '点击选择抄送人' }}</p>
        </a-form-model-item>
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
              <upload-attachment
                ref="uploadRef"
                :val-name="valName"
                :class="isDisabled ? 'isDisabled' : ''"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template slot="footer">
      <div class="footer_right">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="handleOk(0)">保存</a-button>
        <!--          <a-button @click="handleOk(1)" :loading="loading" style="color:#fff;background-color:#52c41a;">保存并提交审核</a-button>-->
      </div>
    </template>
    <detail-vue
      ref="detailVue"
      :dialog-visible="detailVisible"
      @ok="detailOk"
      @close="detailClose"
    />
    <public-dialog
      :title="publicDia.title"
      :dialog-visible="publicDia.visible"
      :component-name="publicDia.comName"
      :is-over="publicDia.isOver"
      @logSuccess="publicDialogSucc"
      @cancel="publicDialogCancel"
    />
    <personnel
      :visible="personVisible"
      :chooseData="personData"
      :isOnce="isOnce"
      @close="personClose"
      @success="personSuccess"
    />
  </a-modal>
</template>

<script>
import personnel from '@/components/personnel'
import publicDialog from '@/components/modelDialog/publicDialog.vue'
import { dealBigMoneys, taxComputation } from '@/utils/common'
import detailVue from '../purchaseRequest/details.vue'
import db from '@/utils/localstorage'
import { getNowFormatDate, FormatTime } from '@/utils/timer'
import uploadAttachment from '@/views/common/Upload'
import { getDefaultCarbonPerson } from '@/utils/index.js'
export default {
  name: 'AddEdit',
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: { personnel, detailVue, publicDialog, uploadAttachment },
  provide () {
    return {
      formData: this
    }
  },
  data () {
    let checkDetails = (rule, value, callback) => {
      // console.log(!this.productList.length, '!this.productList.length')
      if (!this.productList.length) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback('请添加采购明细')
      }
      callback()
    }
    return {
      isProjectType: true,
      publicDia: { visible: false, isOver: false },
      loading: false,
      form: {
        payInvoice: 0,
        ourName: db.get('USER').username,
        status: 0,
        isTrue: false,
        invoiceBo: {}, // 收票记录
        totalPrice: ''
      },
      maskDiv: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      spLabelCol: { span: 10 },
      spWrapper: { span: 14 },
      formRules: {
        projectName: [{ required: true, message: '请选择对应项目', trigger: 'change' }],
        suppliersName: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        purchaseRequisitionId: [{ required: true, message: '请选择采购申请', trigger: 'change' }],
        purchaseDate: [{ required: true, message: '请选择采购日期', trigger: 'change' }],
        totalPrice: [{ required: true, message: '请输入采购金额', trigger: 'blur' }],
        classification: [{ required: true, message: '请选择采购分类', trigger: 'blur' }],
        subject: [{ required: true, message: '请输入主题', trigger: 'blur' }],
        productList: [{ required: true, validator: checkDetails, trigger: 'blur' }],
        invoiceBo: {
          invoiceMoney: [{ required: true, message: '请输入票据金额', trigger: 'blur' }],
          invoiceType: [{ required: true, message: '请选择票据类型', trigger: 'change' }],
          invoiceContent: [{ required: true, message: '请输入发票内容', trigger: 'blur' }]
        }
      },
      purchasingReqList: [],
      productDetails: [],
      paymentMethodList: [],
      billTypeList: [],
      // 付款计划 - 动态表单
      dynamicValidateForm: {
        domains: [
          {
            payMoney: '',
            payDate: '',
            payMode: ''
          }
        ]
      },
      formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 }
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      },
      detailVisible: false,
      productList: [],
      productColumns: [
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 150,
          ellipsis: true
        },
        {
          title: '产品型号',
          dataIndex: 'productType',
          width: 150,
          ellipsis: true
        },
        {
          title: '产品规格',
          dataIndex: 'productSpecification',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'productUnit',
          width: 100
        },
        {
          title: '数量',
          dataIndex: 'productCount',
          width: 100
        },
        {
          width: 100,
          title: '采购价',
          dataIndex: 'productCost'
        },
        {
          width: 100,
          title: '总价',
          dataIndex: 'productTotalCost'
        },
        {
          width: 150,
          title: '产品备注',
          ellipsis: true,
          dataIndex: 'productRemark'
        }
      ],
      // 选择人员
      isOnce: false,
      personVisible: false,
      personData: {}, // 选择人员数据
      orderList: [], // 关联订单数组
      // 上传附件
      uploadFileList: [],
      valName: 'uploadFileList',
      extraPayType: [],
      cgTypeList: [],
      isDisabled: false, // 审核通过允许修改对应项目
      productDetailMoney: '', // 产品明细金额
      flag: false, // 判断是否从采购申请进入
      dataSourceCopy: [],
      isincludingTax: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  mounted () {
    // this.getReqList()
    this.initDectData()
  },
  methods: {
    dealBigMoneys,
    ticketReceiptClick (e) {
      // console.log(e, '========')
      if (e === '406') {
        this.$set(this.form.invoiceBo, 'includingTax', 1)
        this.$set(this.form.invoiceBo, 'taxRate', 0)
        this.$set(this.form.invoiceBo, 'taxes', '')
        this.isincludingTax = false
      } else if (e === '175') {
        this.$set(this.form.invoiceBo, 'includingTax', 0)
        this.$set(this.form.invoiceBo, 'taxRate', '')
        this.$set(this.form.invoiceBo, 'taxes', '')
        this.isincludingTax = true
      } else {
        this.isincludingTax = false
        this.$set(this.form.invoiceBo, 'taxRate', '')
        this.$set(this.form.invoiceBo, 'taxes', '')
      }
    },
    getDefaultPerson () {
      getDefaultCarbonPerson(1).then((res) => {
        if (res) {
          this.$set(this.form, 'userId', res.userIdList)
          this.$set(this.form, 'userName', res.userNameList)
        }
      })
    },
    countMoney (val) {
      if (val === 1) {
        this.productDetailMoney = this.form.totalPrice
      } else if (val === 2) {
        if (this.form.extraPayMoney > 0) {
          this.form.totalPrice = Number(this.productDetailMoney) + Number(this.form.extraPayMoney)
        }
      }
    },
    maskClick () {
      this.resetForm()
      this.$emit('close')
    },
    payTypeChange () {
      if (this.form.payType >= 0) {
        // 初始化付款金额、款项日期
        this.dynamicValidateForm.domains[0].payMoney = this.form.totalPrice
        this.dynamicValidateForm.domains[0].payDate = FormatTime(new Date(), 'YYYY-MM-DD')
        this.dynamicValidateForm.domains[0].payMode = this.paymentMethodList[1].label
        this.$forceUpdate()
        // 当选中-付款记录时  只有一条数据
        if (this.form.payType === 1 && this.dynamicValidateForm.domains.length > 1) {
          this.dynamicValidateForm.domains.splice(1, this.dynamicValidateForm.domains.length - 1)
        }
      }
      if (this.form.isTrue) {
        this.form.invoiceBo.moneyStatus = this.form.payType
      }
    },
    payTypeClick0 () { // 再次点击  清空值、取消选中
      if (this.form.payType === 0) {
        this.form.payType = null
        this.clearFkForm() // 清空付款计划/记录的表单内容
      }
    },
    payTypeClick1 () {
      if (this.form.payType === 1) {
        this.form.payType = null
        this.clearFkForm()
      }
    },
    clearFkForm () {
      this.dynamicValidateForm.domains = [
        {
          payMoney: '',
          payDate: '',
          payMode: ''
        }
      ]
    },
    isTrueChange () {
      if (this.form.isTrue) {
        // 设置默认数据
        this.$set(this.form.invoiceBo, 'invoiceMoney', this.form.totalPrice)
        this.$set(this.form.invoiceBo, 'invoiceType', this.billTypeList[0].label)
        this.$set(this.form.invoiceBo, 'includingTax', 0)
        this.$set(this.form.invoiceBo, 'taxRate', 0)
        this.$set(this.form.invoiceBo, 'taxes', 0)
      }
    },
    isTrueClick () { // 生成收票记录  再次点击-则为取消选中 并 清空收票记录内容
      this.form.invoiceBo.moneyStatus = this.form.payType
      if (this.form.isTrue) {
        this.form.isTrue = false
        this.form.invoiceBo = {}
      }
    },
    payInvoiceChange () { // 点击无需收票和未收票的话，清空收票记录内容
      if (this.form.payInvoice !== 1) {
        this.form.invoiceBo = {}
      }
    },
    rateChange () {
      if (this.form.invoiceBo.includingTax === 1) {
        delete this.form.invoiceBo.taxes
      } else {
        this.countTaxes()
      }
    },
    countTaxes () { // 计算税金  是否含税、金额、税率
      if (this.form.invoiceBo.includingTax === 0 && this.form.invoiceBo.invoiceMoney && this.form.invoiceBo.taxRate) {
        this.$set(this.form.invoiceBo, 'taxes', taxComputation(this.form.invoiceBo.invoiceMoney, this.form.invoiceBo.taxRate))
      }
    },
    // countTaxRate () { // 计算税金  是否含税、金额、税率
    //   if (this.form.invoiceBo.includingTax === 0 && this.form.invoiceBo.invoiceMoney && this.form.invoiceBo.taxRate) {
    //     this.$set(this.form.invoiceBo, 'taxes', taxComputation(this.form.invoiceBo.invoiceMoney, this.form.invoiceBo.taxRate))
    //   }
    // },
    initDectData () {
      // 加载字典-付款方式
      this.paymentMethodList = this.$store.state.account.dictData.paymentMethodList
      // 加载字典-票据类型
      this.billTypeList = this.$store.state.account.dictData.billTypeList
    },
    getReqList () { // 获取采购申请列表
      this.$get('/purchaseRequisition/list').then(res => {
        if (res.data.status === 1) {
          this.purchasingReqList = res.data.data.rows
        }
      })
    },
    getOrderList () { // 根据所选的订单客户查询关联订单
      this.$get('/contract/getByCustomerId', { customerId: this.form.customerId }).then(res => {
        if (res.data.status === 1) {
          this.orderList = res.data.data.rows
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    onChange (date, dateString, index) {
      this.dynamicValidateForm.domains[index].payDate = dateString
    },
    // 编辑产品明细
    productDetailClick () {
      if (this.isDisabled) return
      this.detailVisible = true
      this.$refs.detailVue.dataSource = JSON.parse(JSON.stringify(this.productList))
      if (this.flag) {
        this.$refs.detailVue.flag = true
        // let datalist = [...this.productList]
        this.$refs.detailVue.dataSourceCopy = JSON.parse(JSON.stringify(this.dataSourceCopy))
      }
    },
    detailOk (proList, delIdsVal, dataSourceCopy) {
      this.productList = proList
      this.delIds = delIdsVal
      if (this.flag) this.dataSourceCopy = dataSourceCopy
      this.countCgMoney(proList)
      this.detailVisible = false
    },
    countCgMoney (proList) {
      // 采购明细-计算采购金额
      let total = 0
      if (proList.length > 0) {
        proList.forEach(element => {
          total = total + element.productTotalCost
        })
        this.form.totalPrice = total
        this.productDetailMoney = total // 产品明细金额
      } else {
        this.form.totalPrice = 0
        this.productDetailMoney = 0
      }
    },
    detailClose () {
      this.countCgMoney(this.productList)
      this.detailVisible = false
    },
    // 添加 付款计划
    addDomain () {
      if (this.isDisabled) return
      this.dynamicValidateForm.domains.push({
        // payMoney: '',
        // payDate: '',
        payMoney: this.form.totalPrice,
        payDate: FormatTime(new Date(), 'YYYY-MM-DD'),
        payMode: this.paymentMethodList[1].value,
        payType: this.form.payType
      })
    },
    // 删减 付款计划
    removeDomain (item) {
      let index = this.dynamicValidateForm.domains.indexOf(item)
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1)
      }
    },
    getDh () {
      this.maskDiv = false
      // 随机生成五位数为申请单号的后五位-设置采购单号
      let timeStr = getNowFormatDate()
      let number5 = Math.floor(Math.random() * 100000)
      this.form.code = `CGD${timeStr}${number5}`
      // 设置默认日期-purchaseDate
      let nowTime = FormatTime(new Date(), 'YYYY-MM-DD')
      this.form.purchaseDate = nowTime
      this.setSelectData()
    },
    setSelectData () {
      // 获取vuex内字典
      let dictObj = this.$store.state.account.dictData
      if (dictObj) {
        this.cgTypeList = dictObj.cgTypeList
        this.extraPayType = dictObj.extraPayTypeList
      }
    },
    timeChange (date, dateString) {
      this.form.purchaseDate = dateString
      this.$forceUpdate()
    },
    reqChange (val) { // 对应采购申请
      this.form.purchaseRequisitionId = val
      // 根据采购申请的id查询产品明细
      this.$get(`/purchaseDetail/listByPurchaseId`, { purchaseId: val, purchaseType: 2, pageSize: -1, pageNum: -1 }).then(res => {
        if (res.data.status === 1) {
          this.productDetails = res.data.data.rows
        }
      })
    },
    otherContractChange (value, option) { // 关联订单
      this.form.otherContractId = option.data.attrs.matterCode
      this.form.otherContractName = value
      // console.log('关联订单', value, option.data.attrs.matterCode)
    },
    setForm (formValue) {
      this.form = { ...formValue }
      // console.log(this.form, '========')
      // 计算明细金额
      this.productDetailMoney = Number(formValue.totalPrice) - Number(formValue.extraPayMoney)
      this.getProDetails(formValue.id)
      this.setSelectData()
      if (formValue.checkStatus !== '' && formValue.checkStatus !== null && formValue.checkStatus !== 2) {
        this.maskDiv = true
      } else if (formValue.checkStatus === 2) {
        this.maskDiv = false
        this.isDisabled = true
      } else {
        this.maskDiv = false
      }
      // 根据合同id查合同Name
      if (formValue.otherContractId) {
        this.$get(`contract/getById`, { id: formValue.otherContractId }).then(res => {
          if (res.data.status === 1) {
            this.$set(this.form, 'otherContractName', res.data.data.contractTitle)
          }
        })
      }
      // 根据客户id查询关联订单客户
      if (formValue.customerId) {
        this.$get(`/customer/getById`, { id: formValue.customerId }).then(res => {
          if (res.data.status === 1) {
            this.$set(this.form, 'customerName', res.data.data.companyName)
          }
        })
        // 根据客户查询关联订单下拉列表
        this.getOrderList()
      }
      // 是否有附件
      if (this.form.fileIds) {
        // string 转 数组  循环获取附件信息
        let fileList = this.form.fileIds.split(',')
        this.$nextTick(() => {
          this.$refs.uploadRef.getFile(fileList)
        })
      }
    },
    getProDetails (idVal, isDel) {
      // 采购申请转的采购单 需要传一个字段去查询未采购的
      let params = {}
      if (isDel) {
        params = {
          purchaseId: idVal,
          productPurchased: 0,
          purchaseType: 1
        }
        // 根据id获取产品明细
        this.$get(`/purchaseDetail/surplusList`, { ...params, pageSize: -1, pageNum: -1 }).then(res => {
          if (res.data.status === 1) {
            if (res.data.data.rows.length === 0 && this.flag) {
              let _this = this
              this.$confirm({
                // title: '确定吗?',
                content: '不存在未转采购单的申请明细了',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                  _this.handleCancel()
                },
                onCancel () {
                  _this.handleCancel()
                }
              })
            }
            this.productList = res.data.data.rows
            // 采购申请转采购单 产品明细id删除
            if (isDel) {
              // 计算总金额
              this.countCgMoney(this.productList)
              this.productList.forEach(item => {
                delete item.id
              })
              this.dataSourceCopy = this.productList
            }
          }
        })
      } else {
        params = {
          purchaseId: idVal,
          purchaseType: 2
        }
        // 根据id获取产品明细
        this.$get(`/purchaseDetail/listByPurchaseId`, { ...params, pageSize: -1, pageNum: -1 }).then(res => {
          if (res.data.status === 1) {
            if (res.data.data.rows.length === 0 && this.flag) {
              let _this = this
              this.$confirm({
                // title: '确定吗?',
                content: '不存在未转采购单的申请明细了',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                  _this.handleCancel()
                },
                onCancel () {
                  _this.handleCancel()
                }
              })
            }
            this.productList = res.data.data.rows
            // 采购申请转采购单 产品明细id删除
            if (isDel) {
              // 计算总金额
              this.countCgMoney(this.productList)
              this.productList.forEach(item => {
                delete item.id
              })
              this.dataSourceCopy = this.productList
            }
          }
        })
      }
      // params.purchaseType = 2 // 采购单
    },
    setNoteData (dataObj, flag) { // 采购申请转采购单数据传输并回显
      // console.log('申请转采购单', dataObj, flag)
      if (flag) this.flag = true
      this.$set(this.form, 'requisitionId', dataObj.id) // 采购申请数据id
      this.$set(this.form, 'projectId', dataObj.projectId)
      this.$set(this.form, 'projectName', dataObj.projectName)
      this.$set(this.form, 'customerId', dataObj.customerId)
      this.$set(this.form, 'customerName', dataObj.customerName)
      this.$set(this.form, 'otherContractId', dataObj.otherContractId) // 关联订单
      this.$set(this.form, 'contractTitle', dataObj.contractTitle) // 关联订单名称
      this.$set(this.form, 'content', dataObj.remark)
      // this.form.requisitionId = dataObj.id
      // this.form.projectId = dataObj.projectId
      // this.form.projectName = dataObj.projectName
      // this.form.customerId = dataObj.customerId
      // this.form.customerName = dataObj.customerName
      // this.form.otherContractId = dataObj.otherContractId // 关联订单
      // this.form.contractTitle = dataObj.contractTitle // 关联订单名称
      // this.form.content = dataObj.remark
      // 根据采购申请的id查询产品明细
      this.getProDetails(dataObj.id, true)
      // 获取采购单号
      this.getDh()
      // 获取关联订单列表
      this.getOrderList()
      this.$forceUpdate()
    },
    openModal (type) { // 弹窗选择一行数据
      this.publicDia.visible = true
      if (type === 'supplier') {
        this.publicDia.title = '选择供应商'
        this.publicDia.comName = 'purchase/supplier'
      } else if (type === 'project') {
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
        this.publicDia.isOver = true
      } else if (type === 'customer') {
        this.publicDia.title = '选择关联订单客户'
        this.publicDia.comName = 'customerManage'
      }
    },
    publicDialogSucc (data, typeVal) { // 数据选择成功-赋值
      if (typeVal === 'projectManage') {
        this.$set(this.form, 'projectId', data.id)
        this.$set(this.form, 'projectName', data.subject)
        // console.log(this.title, `[新建]${this.$tree([], 'purchase/purchaseNote/index')}`)
        if (this.title === `[新建]${this.$tree([], 'purchase/purchaseNote/index')}`) {
          if (data.customerType === 2) {
            this.$set(this.form, 'suppliersName', data.mainCustomer)
            this.$set(this.form, 'supplierId', data.mainCustomerId)
          } else {
            this.$set(this.form, 'suppliersName', '')
            this.$set(this.form, 'supplierId', '')
          }
        }
        this.$refs.formRef && this.$refs.formRef.clearValidate('projectName')
      } else if (typeVal === 'purchase/supplier') {
        this.$set(this.form, 'supplierId', data.id)
        this.$set(this.form, 'suppliersName', data.companyName)
        this.$refs.formRef && this.$refs.formRef.clearValidate('suppliersName')
      } else if (typeVal === 'customerManage') {
        this.$set(this.form, 'customerId', data.id)
        this.$set(this.form, 'customerName', data.companyName)
        this.getOrderList()
      }
      this.publicDia.visible = false
    },
    publicDialogCancel () { // 取消选择数据
      this.publicDia.visible = false
    },
    openPerson (type) {
      if (this.isDisabled) return
      this.openPersonType = type
      // 抄送人为多选  所有者单选
      if (type === 'user') {
        this.isOnce = false
      } else {
        this.isOnce = true
      }
      this.personVisible = true
    },
    personSuccess (data, type) {
      var username, userId
      // 单选 和 多选 人员数据
      if (type === 'checkType') {
        data.forEach(item => {
          if (!username) {
            username = item.username
            userId = item.userId
          } else {
            username += ',' + item.username
            userId += ',' + item.userId
          }
        })
      } else if (type === 'radioType') {
        username = data.username
        userId = data.userId
      }
      // 判断数据赋值
      if (this.openPersonType === 'user') {
        this.form.userId = userId
        this.form.userName = username
      } else if (this.openPersonType === 'owner') {
        this.form.our = userId
        this.form.ourName = username
      }
      this.personVisible = false
    },
    // 取消选择抄送人
    personClose () {
      this.personVisible = false
    },
    handleOk (val) {
      // console.log(this.form.invoiceBo.taxRate, this.form.isTrue)
      if (this.form.isTrue && this.form.payInvoice === 1) {
        if (this.isincludingTax && (!this.form.invoiceBo.taxRate || this.form.invoiceBo.taxRate === '0')) {
          this.$message.warning('专用发票请填写税率')
          return
        }
      }
      if (this.dynamicValidateForm.domains[0].payMoney) {
        var totalPrice = 0
        this.dynamicValidateForm.domains.forEach(e => {
          totalPrice += e.payMoney
        })
        // 动态范围判断（支持负数范围）
        if (this.form.totalPrice >= 0) {
          if (totalPrice < 0 || totalPrice > this.form.totalPrice) {
            this.$message.warning(`金额应在 0 ~ ${this.form.totalPrice} 之间`)
            return
          }
        } else {
          if (totalPrice < this.form.totalPrice || totalPrice > 0) {
            this.$message.warning(`金额应在 ${this.form.totalPrice} ~ 0 之间`)
            return
          }
        }
        // if (totalPrice > this.form.totalPrice) {
        //   this.$message.warning(`金额不能大于采购单金额`)
        //   return
        // }
        // console.log(this.dynamicValidateForm.domains, totalPrice)
      }
      if (val === 1) {
        this.form.checkFlag = val
      } else {
        this.form.checkFlag = null
      }
      // console.log(this.form, '表单数据', this.form.invoiceBo)
      // 首先验证-付款情况/记录表单
      if (this.form.payTyp >= 0) {
        this.$refs.dynamicValidateForm.validate((valid) => {
          if (valid) {
            this.formRuleAddOrEdit()
          }
        })
      } else {
        this.formRuleAddOrEdit()
      }
    },
    formRuleAddOrEdit () {
      this.$refs.formRef.validate((valid) => {
        // setCount字段代表是否对图片进行删除/上传操作，为0时附件未发生变化则无需赋值
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        if (this.dynamicValidateForm.domains[0].payMoney) {
          // 添加payStatus
          this.dynamicValidateForm.domains.forEach(item => {
            item.payStatus = this.form.payType
            item.payType = this.form.payType
          })
          this.form.payPlanBoList = JSON.stringify(this.dynamicValidateForm.domains)
        } else {
          delete this.form.payPlanBoList
        }
        // console.log('form', this.form)
        if (valid) {
          // 判断收票记录、付款情况是否需要转成JSON字符串进行传输、删除字段
          if (this.form.isTrue && this.form.invoiceBo.invoiceMoney) {
            this.form.invoiceBo = JSON.stringify(this.form.invoiceBo)
          } else {
            // this.form.invoiceBo = ''
            delete this.form.invoiceBo
          }
          // 采购明细
          this.loading = true
          this.form.payMoney = 0
          this.form.purchaseMoney = 0
          // 采购id类型（1：采购申请，2：采购单）
          if (this.productList && this.productList.length > 0) {
            this.productList.forEach(element => {
              element.purchaseType = 2
            })
            this.form.purchaseDetailBoList = JSON.stringify(this.productList)
          }
          if (this.title === `[新建]${this.$tree([], 'purchase/purchaseNote/index')}`) {
            this.$post('/purchase/add', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          } else {
            this.$post('/purchase/update', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        }
      })
    },
    resetForm () {
      this.uploadFileList = []
      this.maskDiv = false
      this.isDisabled = false
      this.flag = false
      setTimeout(() => {
        this.productDetails = []
        this.productList = []
        this.form = {
          payInvoice: 0,
          ourName: db.get('USER').username,
          status: 0,
          isTrue: false,
          invoiceBo: {}, // 收票记录
          totalPrice: ''
        }
        this.dynamicValidateForm = {
          domains: [
            {
              payMoney: '',
              payDate: '',
              payMode: ''
            }
          ]
        }
      }, 500)
    },
    handleCancel () {
      this.productList = []
      this.resetForm()
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scope>
.isDisabled {
  pointer-events: none;
}

.numberCla {
  color: #1890ff;
  padding-top: 4px;
  font-size: 16px;
  font-weight: bold;
}
.maskDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.2);
}
.deleteRowIcon {
  margin: 10px 0 0 20px;
}
.cgClass {
  .ant-empty-normal {
    margin: 0;
  }
}
.colFlex {
  display: flex;
  justify-content: space-between;
}
.domain-style .ant-form-item .ant-form-item-label {
  width: 100px !important;
}
.domain-style {
  justify-content: space-between;
  .ant-form-item {
    width: 100%;
  }
}
.colFlex {
  .ant-form-item {
    width: 100%;
    .ant-form-item-label {
      width: auto !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/purchaseNote/addEdit.vue